import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from "react-responsive-modal";
import { getlanguagelist } from "../../../helpers/changelanguage";
import Cropper from 'react-easy-crop';
import html2canvas from 'html2canvas';
import "./ProfileImageUpload.css";
import { cloudinarySingleUploader } from '../../../helpers/cloudinaryFileUploader';
import $ from "jquery";
import axios from 'axios';
import firebase from 'firebase/app';
import firebaseConfig from '../../../../src/config';
import { ToastsStore} from 'react-toasts';
import {profilePictureUpload} from "../../../actions/userAction"

const customStyles = {
    width: '600px',
    height : '500px',
    position: 'relative'
  };



class ProfileImageUpload extends Component {
    constructor(props) {
      super(props);
      this.previewCanvas = React.createRef();
      this.state = {
        open            : false,
        image           : '',
        crop: { x: 0, y: 0 },
        zoom: 1,
        aspect: 4 / 3
      };
      this.choseFile          = this.choseFile.bind(this);
      this.onCloseModal       = this.onCloseModal.bind(this);
      this.onCropChange       = this.onCropChange.bind(this);
      this.onCropComplete     = this.onCropComplete.bind(this);
      this.imagebase          = this.imagebase.bind(this);
      this.onZoomChange       = this.onZoomChange.bind(this);
      this.uploadProfileImage = this.uploadProfileImage.bind(this);
      this.extractimageextension = this.extractimageextension.bind(this);
      this.base64tofile          = this.base64tofile.bind(this);
      this.saveImagedata         = this.saveImagedata.bind(this);
    }

    componentDidMount() {
    }
   
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
      if(this.props.changeprofilepic != nextProps.changeprofilepic){
       // $("#image-upload-loader").hide();
      }
    }

  /*
  Description: Set User Current Tab Value
  */
   onCloseModal() {
    this.setState({ open : false});
   };

   choseFile(e){
    let file = e.target.files[0];
    let reader = new FileReader();
    let url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
        
        this.setState({
         image  : reader.result,
         open   : true
        });
    }.bind(this);
   }
  onCropChange(crop){
    this.setState({ crop })
  }
 
  onCropComplete(croppedArea, croppedAreaPixels){
    //console.log( croppedAreaPixels);
    const canvas = this.previewCanvas.current;
    this.imagebase(canvas,this.state.image,croppedAreaPixels);
      
  }
 
  onZoomChange(zoom){
    this.setState({ zoom })
  }
 

imagebase(canvasRef,image64,pixel){
  const canvas  = canvasRef;
  canvas.width  = pixel.width;
  canvas.height = pixel.height;
  const ctx     = canvas.getContext('2d');
  const image   = new Image();
  image.src     = image64;
  image.onload  = function(){
    ctx.drawImage(image, pixel.x, pixel.y, pixel.width, pixel.height, 0, 0, pixel.width, pixel.height);
  };
 
}
extractimageextension(base64Data){
    return base64Data.substring('data:image/'.length,base64Data.indexOf(';base64'))

}
base64tofile(base64,fileName){
    let arr = base64.split(','),mime = arr[0].match(/:(.*?);/)[1],
    bstr    = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n) 
    while (n--){
        u8arr[n]  = bstr.charCodeAt(n)
    }
    return new File([u8arr], fileName, {type : mime})
}

  uploadProfileImage(){
    
    const canvas = document.getElementById('mycanvas');
    const dataURL = canvas.toDataURL();
      
      const canvasRef = this.previewCanvas.current;
      const image     = dataURL;
      const fileExt   = this.extractimageextension(image);
      const filename  = ((this.props.currentUserDetails.full_name).toLowerCase()).replace('','_') + '_' + Date.now() + fileExt;
      const file      = this.base64tofile(image,filename);
        
    let uploadPathImage = `uploads/${this.props.currentUserDetails.id}/profile_image`;
    //let uploadResponse  = cloudinarySingleUploader(file,uploadPathImage);

    let formData = new FormData();
    formData.append("api_key",'285759666786543');
    formData.append("file", file);
    formData.append("folder", uploadPathImage);
    formData.append("upload_preset", 'lgo8izk7');
   // $("#image-upload-loader").show();
    $('#profile-img').attr('src','/assets/images/preloader.gif');
    
    this.setState({
      open   : false
    });
     let obj = this;
    axios.post('https://api.cloudinary.com/v1_1/www-baaldahab-com/upload/', formData, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      .then(function (response) {
        $("#profile-img").attr('src',response.data.url);
        $(".ownimage").attr('src',response.data.url);
        obj.saveImagedata(response.data);
        
      })
  
    
   
  } 

  saveImagedata(profileImage){

    const userdetails  = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
    let userdetailsArr = JSON.parse(userdetails);
    firebase.auth().signInWithCustomToken(userdetailsArr.firebase_auth_token)
    .then((userCredential) => {
   
     
        this.messageRef = firebase.database().ref().child('user').child(this.props.currentUserDetails.id);
        this.messageRef.update({
          'avata': profileImage.url
        });
        const user = this.props.currentUserDetails;
        user.image = profileImage.url;
        localStorage.setItem('userDetails', JSON.stringify(user));
        sessionStorage.setItem('userDetails', JSON.stringify(user));
        let reqParam = {
          updated_field : JSON.stringify([{"key": "PROFILE PICTURE","value" : profileImage.public_id,"control" : "FRIENDS"}]),
          user          : user
        }
        this.props.profilePictureUpload(reqParam);
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorMessage);
      ToastsStore.error(errorMessage);
      // ...
    }); 
  }

  render() {
    const{ urlId } = this.props;
    let  languagelist = getlanguagelist();
    return (
      
            <div className="image-upload-div">
              
                <div className="image-upload">
                <label htmlFor="myfile">
                    <i className="fa fa-camera" aria-hidden="true"></i>
                </label> 
                   <input type= "file" id="myfile" name="myfile" onChange={this.choseFile} accept="image/*" style={{paddingLeft: '46%'}}></input>
                </div>
              
            <Modal open={this.state.open} onClose={this.onCloseModal} showCloseIcon={false} center>
                    
                    <div className="modal-header2">
                        <button type="button" className="close" onClick={this.onCloseModal} ><img src="/assets/images/close_btn.png"/></button>
                    </div>
                    <div className="modal-body" style={customStyles}>
                    
                        <Cropper
                            image={this.state.image}
                            crop={this.state.crop}
                            zoom={this.state.zoom}
                            aspect={this.state.aspect}
                            onCropChange={this.onCropChange}
                            onCropComplete={this.onCropComplete}
                            onZoomChange={this.onZoomChange}
                        />
                        <br/>
                        <canvas ref={this.previewCanvas} id="mycanvas" style={{display: 'none'}}></canvas>
                    </div>
                    <div className="modal-footer">
                    <input type="button" className="btn_5" value={languagelist.save} onClick={this.uploadProfileImage}/>
                    </div>
                    
              

            </Modal>
            </div>
      
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUserDetails: state.login.user,
    changeprofilepic  : state.changeprofilepic.profilePic
  }
}
const mapDispatchToProps = dispatch => {
  return {
    profilePictureUpload  : bindActionCreators(profilePictureUpload, dispatch),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileImageUpload);

